import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULTS = {
    store_enabled: false,
    ticket_banner_enabled: false,
    ticket_header: "Winning Ticket Number",
    ticket_body: "The winning ticket number will be posted here. Please check back soon.",
    ticket_number: "Coming Soon",
};

const SettingsContext = createContext({ settings: DEFAULTS, loading: true });

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState(DEFAULTS);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`${API}/settings`)
            .then(r => setSettings({ ...DEFAULTS, ...r.data }))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    const value = useMemo(() => ({ settings, loading }), [settings, loading]);

    return (
        <SettingsContext.Provider value={value}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = () => useContext(SettingsContext);
